module.exports = __webpack_public_path__ + "static/media/polaroid2.b046df98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/polaroid2.jpg
// module id = 353
// module chunks = 0